"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.primitiveComparator = void 0;
require("../../core");
const primitiveComparator = (prevParams, nextParams) => {
    const keys = Object.keys(prevParams);
    const nextPropsKeys = Object.keys(nextParams);
    if (keys.length !== nextPropsKeys.length) {
        return false;
    }
    let isEqual = true;
    for (let i = 0; i <= keys.length; i++) {
        if (prevParams[keys[i]] !== nextParams[keys[i]]) {
            isEqual = false;
            break;
        }
    }
    return isEqual;
};
exports.primitiveComparator = primitiveComparator;
//# sourceMappingURL=primitiveComparator.js.map